@if (isRootNode() && isExpandable()) {
  <button
    #rootTrigger="matMenuTrigger"
    mat-button
    class="flex items-center w-max"
    [ngClass]="itemCssClass()"
    [matMenuTriggerFor]="menu"
    (click)="onClickItem(item()?.handle ?? '')">
    <span>
      {{ item()?.label }}
      <mat-icon svgIcon="chevron" class="!h-3 !w-3 ml-1 rotate-90"></mat-icon>
    </span>
  </button>
} @else if (isRootNode() && !isExpandable()) {
  <button
    mat-button
    class="flex items-center w-max"
    [ngClass]="itemCssClass()"
    (click)="onClickItem(item()?.handle ?? '')">
    <span>
      {{ item()?.label }}
    </span>
  </button>
} @else if (!isRootNode() && isExpandable()) {
  <button
    #itemTrigger="matMenuTrigger"
    mat-menu-item
    [matMenuTriggerFor]="menu"
    (mouseenter)="itemTrigger.openMenu()"
    (click)="onClickItem(item()?.handle ?? '')"
    (click)="closeMenu()">
    {{ item()?.label }}
  </button>
}

<mat-menu #menu="matMenu" class="!bg-[var(--mat-sys-surface-container-lowest)]">
  @for (node of childNodes(); track node) {
    <button mat-menu-item style="padding: 0">
      @if (node.expandable) {
        <store-horizontal-menu-item
          [handle]="node?.handle ?? ''"
          (forceMenuClosing)="closeMenu()">
        </store-horizontal-menu-item>
      } @else {
        <button mat-menu-item (click)="onClickItem(node?.handle ?? '')">
          {{ node?.label }}
        </button>
      }
    </button>
  }
</mat-menu>
